<as-empty-simple
  *ngIf="type === 'simple'"
  [title]="title"
>
</as-empty-simple>
